import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AuthService } from "@app/auth/services/authentication/auth.service";

function checkUserRole() {
  const auth = inject(AuthService);
  const isAdmin = auth.userRole === "ADMIN" || auth.userRole === "DISTRIBUTOR";
  return isAdmin;
}

export const DistributorGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  if (!auth.isLoggedIn()) {
    auth.logout();
    return false;
  }

  return auth.isLoggedIn() && checkUserRole();
};
